import React from 'react'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import { ChevronLeft, ChevronRight } from 'lucide-react'

import moment from 'moment'
import { jaLocaleUtils } from 'components/dayPickerLocaleUtils'
import 'react-day-picker/lib/style.css'

// WHY: react-day-picker 標準 NavBar の矢印は CSS background 依存で、Vite だとサイズ指定が
// 効かず過大表示になる。アイコン標準の lucide シェブロンを navbarElement で描画して安定させる。
const navButtonBaseStyle = {
  position: 'absolute',
  top: '1rem',
  background: 'transparent',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  color: '#C1C1C1',
  lineHeight: 0,
}

const Navbar = ({
  onPreviousClick,
  onNextClick,
  showPreviousButton,
  showNextButton,
  className,
}) => (
  <div className={className}>
    <button
      type="button"
      aria-label="Previous Month"
      onClick={() => onPreviousClick()}
      style={{
        ...navButtonBaseStyle,
        left: '0.5rem',
        visibility: showPreviousButton ? 'visible' : 'hidden',
      }}
    >
      <ChevronLeft size={20} aria-hidden={true} />
    </button>
    <button
      type="button"
      aria-label="Next Month"
      onClick={() => onNextClick()}
      style={{
        ...navButtonBaseStyle,
        right: '0.5rem',
        visibility: showNextButton ? 'visible' : 'hidden',
      }}
    >
      <ChevronRight size={20} aria-hidden={true} />
    </button>
  </div>
)

export class DayPickerForm extends React.Component {
  render() {
    const { value, onChange, isDisabled, placeholder, id } = this.props
    return (
      <DayPickerInput
        onDayChange={onChange}
        value={value}
        placeholder={placeholder || 'YYYY-MM-DD'}
        inputProps={{
          'data-dg-id': id ? `form-input-${id}` : undefined,
          readOnly: true,
          disabled: isDisabled,
        }}
        dayPickerProps={{
          localeUtils: jaLocaleUtils,
          locale: 'ja',
          firstDayOfWeek: 0,
          navbarElement: <Navbar />,
          captionElement: ({ date }) => (
            <div className="DayPicker-Caption" role="heading">
              <div>{moment(date).format('YYYY年 MM月')}</div>
            </div>
          ),
        }}
      />
    )
  }
}

export default DayPickerForm
